var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"movable",rawName:"v-movable"}],staticClass:"resize-module",class:{ m: _vm.move, r: _vm.right, b: _vm.bottom},style:(_vm.style),on:{"move:start":_vm.moveDrawStart,"move":_vm.moveDraw,"move:end":_vm.moveDrawEnd}})}
var staticRenderFns = []

export { render, staticRenderFns }